<template>
  <nav>
    <div
      class="nav--cross"
      v-on:click="handleCross"
    >
      <CrossIcon/>
    </div>
    
    <ul>
      <li class="link-applicastions">
        <router-link 
          to="/applications"
          activeClass="active"
        >
          Application info
        </router-link>
      </li>

      <li class="link-users">
        <router-link 
          to="/users"
          activeClass="active"
        >
          Users
        </router-link>
      </li>

      <li>
        <router-link 
          to="/lessons"
          activeClass="active"
        >
          Lessons
        </router-link>
      </li>

      <li>
        <router-link 
          to="/modules"
          activeClass="active"
        >
          Modules
        </router-link>
      </li>

      <li>
        <router-link 
          to="/push-notifications"
          activeClass="active"
        >
          Push notifications
        </router-link>
      </li>

      <li>
        <router-link 
          to="/questionnaires"
          activeClass="active"
        >
          Questionnaires
        </router-link>
      </li>

      <li>
        <router-link 
          to="/export"
          activeClass="active"
        >
          Export
        </router-link>
      </li>

      <li>
        <router-link 
          to="/statistics"
          activeClass="active"
        >
          Statistics
        </router-link>
      </li>

      <li>
        <router-link 
          to="/images?page=1&used=&tag=&yearmonth=&keyword="
          activeClass="active"
        >
          Images
        </router-link>
      </li>

      <li>
        <router-link 
          to="/videos?page=1&tag=&yearmonth=&keyword="
          activeClass="active"
        >
          Videos
        </router-link>
      </li>

      <li>
        <router-link 
          to="/documents?page=1&tag=&yearmonth=&keyword=&extension="
          activeClass="active"
        >
          Documents + audio
        </router-link>
      </li>

      <li>
        <a v-on:click="handleLogout">
          Logout
        </a>
      </li>
    </ul>

    <img
      src="../../../assets/logo.png"
      title=""
      alt=""
    >
  </nav>
</template>

<script>
  import { API } from '../../../services/api.ts'
  import CrossIcon from '../../../icons/cross.vue'

  export default {
    name: 'Navigation',
    components: {
      CrossIcon
    },
    methods: {
      handleCross: function() {
        const navigation = document.querySelector('nav');
        navigation.style.opacity = '0';
        navigation.style.visibility = 'hidden';
      },
      handleLogout: function() {
        localStorage.removeItem('token');
        localStorage.removeItem('authenticated');
        localStorage.removeItem('selectedApplicationId');
        localStorage.removeItem('selectedApplicationName');
        localStorage.removeItem('isAdmin');

        this.$router.push({ name: 'login'});
      }
    },
    mounted() {
      if (
        localStorage.isAdmin === 'false'
        && this.$route.name !== 'application'
      ) {
        let linkApplications = this.$el.querySelector('.link-applicastions');
        let linkUsers = this.$el.querySelector('.link-users');
        
        linkApplications.style.display = 'none';
        linkUsers.style.display = 'none';
      }
    }
  }
</script>

<style lang="scss">
  @import "../../../styles/components/mediaQueries.scss";

  nav {
    position: relative;
    position: fixed;    
    background-color: var(--black);
    width: var(--navigation-width);
    height: 100vh;
    box-sizing: border-box;

    @include media-sm {
      width: 100%;
      z-index: 10;
      opacity: 0;
      visibility: hidden;
      transition: 0.2s;
    }

    .nav--cross {
      position: absolute;
      top: 15px;
      right: 15px;
      display: none;

      @include media-sm {
        display: block;
      }

      svg {

        path {
          fill: var(--white);
        }
      }
    }

    ul {
      padding: 15px;
      padding-top: 90px;

      @include media-sm {
        padding-top: 50px;
      }

      li {

        a {
          display: block;
          border-radius: 3px;
          padding: 8px 15px;
          color: var(--white);
          font-size: 16px;
          transition: 0.2s;
        }

        .active {
          background-color: var(--blue);
        }
      }
    }

    img {
      width: 87px;
      margin: auto;
      position: absolute;      
      right: 0;
      left: 0;
      bottom: 15px;
    }

    .nav--show {
      opacity: 1;
      visibility: visible;
    }
  }
</style>